const strictCompare = (str1, str2) => str1.localeCompare(str2) === 0

exports.insertIntoArray = (obj, key, nestedKey) => {
  if (!obj || !obj[key]) return []
  return nestedKey ? [obj[key][nestedKey]] : [obj[key]]
}

exports.filterEdgesByLocale = (edges, locale) =>
  edges
    .map(({ node }) => node)
    .filter(({ node_locale: origin }) => strictCompare(origin, locale))

exports.filterByLocale = (arr, locale) =>
  arr.filter(
    ({ node_locale: nl }) =>
      nl.localeCompare(locale, undefined, {
        sensitivity: 'accent',
      }) === 0,
  )

exports.extractHTML = (obj, prop) => {
  if (!(prop in obj) || obj[prop] === null) return null
  const { html } = obj[prop].childContentfulRichText

  return {
    dangerouslySetInnerHTML: {
      __html: html,
    },
  }
}
